export function formatDuration(seconds: number): string {
  const wholeSeconds = Math.round(seconds)
  return `${Math.floor(wholeSeconds / 60)}:${String(wholeSeconds % 60).padStart(2, '0')}`
}
